import { useDocumentsQuery } from "./documents-query.hook";

const useTrackDocuments = ({trackId}:{trackId:string}) => {
  const { data, isLoading, isError } = useDocumentsQuery({ trackId });

  return {
    data,
    isLoading,
    isError,
  };
};

export default useTrackDocuments;
